export class GetOfferIdLeadsByOffersId {
  leadIds: string[];

  constructor(leadIds?: string[]) {
    this.leadIds = leadIds;
  }
}
